import React, { useEffect, useRef, useState } from 'react'
import { Container } from '@orbital/games-frontend-library'
import {
  BetReplyWrapper,
  BetReplyBox,
  Header,
  NotFound,
} from './BetReplyStyles'
import Close from './elements/Close'
import RoundInfo from './elements/RoundInfo'
import Seeds from './elements/Seeds'
import { useClickOutside } from '../../helpers/useClickOutside'
import getBetReply from './helpers/getBetReply'
import { betReplyType } from '../../cyberdice/interfaces'

interface BetReply_props {
  handlePopup: (b: boolean) => void
  handleNotification: any
  betReply: betReplyType
  id: string
  roundId: string
  audio: any
  prec: number
}

export default function BetReply({
  handlePopup,
  handleNotification,
  betReply,
  id,
  audio,
  roundId,
  prec,
}: BetReply_props) {
  const { BET_ID, BET_INFO, SEED, USER_ID } = getBetReply(betReply, prec, id)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const infoRef = useRef<any>(null)
  const [handleClickInside] = useClickOutside(infoRef, handlePopup)

  useEffect(() => {
    if (roundId === BET_ID.roundId.toString()) {
      setTimeout(() => {
        setIsLoading(false)
      }, 1000)
    }
  }, [BET_ID.content, roundId])

  return (
    <Container>
      <BetReplyWrapper>
        <BetReplyBox
          ref={infoRef}
          onClick={() => handleClickInside()}
          className='infoBox'
        >
          {!isLoading ? (
            <>
              <Header>
                {BET_ID.title} <p>#{BET_ID.content}</p>
              </Header>
              <RoundInfo content={BET_INFO} />
              {USER_ID === id && (
                <Seeds pf={SEED} handleNotification={handleNotification} />
              )}
            </>
          ) : (
            <NotFound>
              Loading <span />
              <span />
              <span />
            </NotFound>
          )}
          <Close handlePopup={handlePopup} audio={audio} />
        </BetReplyBox>
      </BetReplyWrapper>
    </Container>
  )
}
